var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7461 21.7279L17.6017 11.9435C17.412 11.8513 17.198 11.8215 16.9904 11.8583C16.7827 11.8951 16.592 11.9966 16.4455 12.1483C16.299 12.3 16.2042 12.4941 16.1746 12.7029C16.1451 12.9117 16.1823 13.1245 16.281 13.3109L20.9656 22.1596C21.0419 22.3037 21.0818 22.4643 21.0818 22.6274C21.0818 22.7905 21.0419 22.9512 20.9656 23.0953L16.281 31.944C16.1823 32.1304 16.1451 32.3432 16.1746 32.552C16.2042 32.7608 16.299 32.9549 16.4455 33.1066C16.592 33.2583 16.7827 33.3598 16.9904 33.3966C17.198 33.4333 17.412 33.4035 17.6017 33.3114L37.7461 23.527C37.9149 23.445 38.0573 23.3171 38.1569 23.1581C38.2564 22.999 38.3092 22.8151 38.3092 22.6274C38.3092 22.4398 38.2564 22.2559 38.1569 22.0968C38.0573 21.9378 37.9149 21.8099 37.7461 21.7279V21.7279Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendArrow);
export default __webpack_public_path__ + "static/media/SendArrow.a87266a8.svg";
export { ForwardRef as ReactComponent };